import { render, staticRenderFns } from "./ed-share-course.component.vue?vue&type=template&id=6de4bc68&scoped=true&"
import script from "./ed-share-course.component.ts?vue&type=script&lang=ts&"
export * from "./ed-share-course.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-share-course.component.scss?vue&type=style&index=0&id=6de4bc68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de4bc68",
  null
  
)

export default component.exports